<template>
  <div class="station-list-accordion">

    <div id="search-station-result-accordion" class="search-station-result-accordion"
         :style="sidebarMode === 'station' ? getStationAccordionStyle() : getRoadAccordionStyle()">
      <div v-if="stationResultList.length === 0" class="text-center">
        검색 조건에 맞는 결과가 없습니다.
      </div>
      <div class="ct-accordion" v-for="(sr, i) in stationResultList" :key="sidebarMode === 'station' ? sr.statId : sr.stationId">

        <!-- START Acoordion Header-->
        <!-- 충전소 검색 Header -->
        <div v-if="sidebarMode === 'station'"
             class="ct-accordion-header" v-b-toggle="`${collapseId}-${i}`"
             @click="showOnMap('station', '',  sr, i)">
          <div class="ct-accordion-title">
            <i class="mdi mdi-ev-station ct-padding-right-25"/>
            <span :title="`${sr.statNm}`"
                  class="ct-padding-right-75">{{ $_utils.textLengthOverCut(sr.statNm, 22, '') }}</span>
            <b-badge class="badge badge-soft-deep-green rounded-pill">
              {{ $_app.code.placeType[sr.kindDetail] }}
            </b-badge>
            <img :src="require(`@/assets/images/map/star-${i%3==0 ? 'on' : 'off'}.png`)" alt="즐겨찾기"
                 height="14" style="float:right; margin: 0 6px 2px 0;" @click="addFavorites()"/>
          </div>
          <div class="ct-accordion-content mt-1">
            <span :title="`${sr.addr}`" v-if="sr.addr">- {{ $_utils.textLengthOverCut(sr.addr, 23, '') }}</span>
            <button class="btn btn-outline-warning btn-sm w-70px" style="float: right; "
                    @click="showNavi(sr)">길 안내
            </button>
<!--            <span style="float: right;">({{ (sr.dist).toFixed(1) }}km)</span>-->
          </div>
          <div v-if="!$_utils.isEmpty(chargerResult) && activeAccordionId === i" class="when-open">
            <div v-if="!$_utils.isEmpty(chargerResult.cp[0].addrDetail) && chargerResult.cp[0].addrDetail !== 'null'">
              <span>상세 위치: </span>
              <span :title="chargerResult.cp[0].addrDetail">
                    {{ $_utils.textLengthOverCut(chargerResult.cp[0].addrDetail, 34, '') }}
                  </span>
            </div>
          </div>
        </div>

        <!-- 길찾기 주변 충전소 Header -->
        <div v-else-if="sidebarMode='road'"
             class="ct-accordion-header" v-b-toggle="`${collapseId}-${i}`"
             :style="i === stationResultList.length-1 ? 'border-style:none': ''"
             @click="showOnMap('kakaoResult', '', sr, i)">
          <div class="ct-accordion-title">
            <i class="mdi mdi-ev-station ct-padding-right-25" />
            <span>{{ sr.statNm }}</span>
<!--            <span class="float-end font-size-12 fw-normal">({{ (sr.dist).toFixed(1) }}km)</span>-->
          </div>
        </div>
        <!-- END Acoordion Header -->

        <!-- START Acoordion Collapse-->
        <b-collapse :id="`${collapseId}-${i}`" accordion="my-accordion" class="station">
          <div v-if="!$_utils.isEmpty(chargerResult) && activeAccordionId === i">
            <div class="my-accordion">

              <!-- START Charger status Info -->
              <div class="status-info-box">
                <div class="accordion-body-title">
                  <i class="mdi mdi-gas-station-outline icon-padding-right"/>
                  <span>충전기 실시간 상태</span>
                </div>

                <div class="accordion-body-content">
                  <div class="status-summary-zone">
                    <div class="row ps-1 charger-speed-zone">
                      <div class="col-6">
                        <span style="font-weight: 700; color: #495057FF;">
                          <i class="mdi mdi-lightning-bolt-outline speed-bolt"/>완속</span>
                        <span :class="chargerResult.enable.ac[0] > 0 ? 'enable-count' : '' ">
                          {{ chargerResult.enable.ac[0] }}대 가능</span>
                        <span class="ct-padding-left-25">(총 {{ chargerResult.enable.ac[1] }}기)</span>
                      </div>
                      <div class="col-6">
                        <span style="font-weight: 700; color: #495057FF;">
                          <i class="mdi mdi-lightning-bolt speed-bolt"/>급속</span>
                        <span :class="chargerResult.enable.dc[0] > 0 ? 'enable-count' : '' ">
                          {{ chargerResult.enable.dc[0] }}대 가능
                        </span>
                        <span class="ct-padding-left-25">(총 {{ chargerResult.enable.dc[1] }}기)</span>
                      </div>
                    </div>

                    <hr class="separator separator--line mb-1" style="border-bottom-color: #36835a"/>

                  </div>

                  <!-- START Charger List -->
                  <div class="charger-scroll-zone" style="max-height: 301px;">
                    <div class="charger-list" v-for="evse in chargerResult.cp" :key="evse.chgerId">
                      <table>
                        <tbody style="border: 1px solid #ced4da;">
                        <tr>
                          <td width="2%"/>
                          <td width="12%"/>
                          <td width="13%"/>
                          <td width="13%"/>
                          <td width="12%"/>
                          <td/>
                          <td/>
                          <td/>
                          <td/>
                        </tr>

                        <tr>
                          <td/>
                          <td colspan="5" class="pt-2 pb-1">
                            <div class="text-start ps-1 fs-6">
                              <!--                              <span class="status-round" :class="$_map_data.getChargerBackground(evse.status)">{{ getStatusName(evse.status) }}</span>-->
                              <span class="fw-bolder">
                                <i :class="`mdi mdi-lightning-bolt${ evse.speed ==='ac' ? `-outline` : '' } speed-bolt`"/> {{ evse.chgerId }}
                              </span>
                              <span>{{ evse.speed ==='ac' ? '완속' : '급속' }}</span>
                              <span class="status-round ms-2 align-middle"
                                    :class="$_map_data.getChargerBackground(evse.status)">{{ getStatusName(evse.status) }}
                          </span>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td rowspan="2"/>
                          <td rowspan="2">
                            <div class="connector-name">DC콤보</div>
                            <div><img :src="$_map_data.getChargerImageSrc(evse, 'combo')" alt="" height="30"/></div>
                          </td>
                          <td rowspan="2">
                            <div class="connector-name">차데모</div>
                            <div><img :src="$_map_data.getChargerImageSrc(evse, 'chademo')" alt="" height="30"/>
                            </div>
                          </td>
                          <td rowspan="2">
                            <div class="connector-name">AC3상</div>
                            <div><img :src="$_map_data.getChargerImageSrc(evse, 'ac3')" alt="" height="30"/></div>
                          </td>
                          <td rowspan="2">
                            <div class="connector-name">완속</div>
                            <div><img :src="$_map_data.getChargerImageSrc(evse, 'ac')" alt="" height="30"/></div>
                          </td>
                          <td colspan="4" style="padding: 0px 10px">
                            <div style="float: left"><span class="connector-name">상태 확인 : </span></div>
                            <div style="float: right"><span>
                          {{ $_map_data.getConvertDateToElapsed(evse.statUpdDt) }}</span></div>
                          </td>
                        </tr>

                        <tr>
                          <td colspan="4" style="padding: 0px 10px">
                            <div style="float: left"><span class="connector-name">최근 충전 : </span></div>
                            <div style="float: right"><span>
                          {{ $_map_data.getConvertDateToElapsed(evse.lastTedt) }}</span></div>
                          </td>
                        </tr>

                        <tr>
                          <td colspan="9" class="pt-1"></td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- END Charger List -->

                </div>
              </div>
              <!-- End Charger status Info -->

              <!-- START Chart -->
<!--              <div class="utz-chart-box" style="position: relative;">

                <div class="spinner-area" v-if="isUtzLoading">
                  <b-spinner variant="main-green" style="width: 2rem; height: 2rem;" role="status" />
                </div>

                <div class="accordion-body-title pb-1">
                  <i class="mdi mdi-chart-bar icon-padding-right"/>
                  <span class="me-1">충전소 이용률</span>
                  <i class="mdi mdi-information-outline fs-5 align-middle" id="utz-tooltip"
                     style="position:relative; z-index: 2; cursor:pointer;"/>
                </div>

                <div class="accordion-body-content py-0 ps-1">
                  <b-tooltip target="utz-tooltip" placement="left" boundary-padding="0">
                    <div class="py-1 pe-1 " style="white-space: pre;">• 배경 색상이 진할수록<br/>
                      높은 요금 구간입니다. (완속 기준)<br/>
                      <b-table-simple small class="mt-1 ms-1">
                        <b-tbody>
                          <b-tr class="border border-0 text-black text-center">
                            <b-th style="background-color: #fef5ee">경부하</b-th>
                            <b-th style="background-color: #fddbc3">중부하</b-th>
                            <b-th style="background-color: #f6b991">최대부하</b-th>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>• 사업자에 따라 일부 이용 정보가 <br/>
                      이용률 집계에 포함되지 않을 수 있습니다.<br/>

                    </div>
                  </b-tooltip>
                  <template v-if="!$_utils.isEmpty(chargerResult.utz) && chargerResult.utz.length > 0">
                    <div class="ms-2 mt-2">최근 1주일 동안 집계된 시간대별 충전소 이용률입니다.</div>
                    <apexchart ref="stationUtzChart" height="90" :options="chargerUtzChartOptions"
                               :series="chargerUtzChartOptions.series" />
                  </template>
                  <template v-else>
                    <div class="pt-3 text-center">
                      <p>이용률 정보가 없습니다.</p>
                    </div>
                  </template>
                </div>
              </div>-->
              <!-- END Chart -->

              <!-- START Charge Price Info -->
<!--              <div class="price-info-box" style="position: relative;">

                <div class="spinner-area" v-if="isPriceLoading">
                  <b-spinner variant="main-green" style="width: 2rem; height: 2rem;" role="status" />
                </div>

                <div class="accordion-body-title">
                  <i class="mdi mdi-cash-multiple icon-padding-right"/>
                  <span>충전 요금</span>
                </div>

                <div v-if="!$_utils.isEmpty(chargePriceResult)">
                  <div class="accordion-body-content">
                    <div>
                      <div v-if="!$_utils.isEmpty(acPriceMax) || !$_utils.isEmpty(dcPriceMax)">
                        <span>• 회원 : </span>
                        <span class="field-text" v-if="!$_utils.isEmpty(acPriceMax)">완속 최대 {{ acPriceMax }} 원</span>
                        <span class="field-text" v-if="!$_utils.isEmpty(dcPriceMax)">, 급속 최대 {{ dcPriceMax }} 원</span>
                      </div>
                      <div v-if="!$_utils.isEmpty(nonMemberPriceMax)" class="pt-1">
                        <span>• 비회원 : </span>
                        <span class="field-text">{{ nonMemberPriceMax }} 원</span>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex">
                    <b-button squared variant="light" size="sm"
                              @click="openChargeFeeModal">
                      <span class="field-text">요금 상세 보기 <i class="mdi mdi-arrow-right"/></span>
                    </b-button>
                  </div>
                </div>
                <div v-else>
                  <div class="accordion-body-content text-center">
                    충전요금 정보가 없습니다.
                  </div>
                </div>


              </div>-->
              <!-- END Charge Price Info -->

              <!-- START Station Info -->
              <div class="station-info-box">
                <div class="accordion-body-title">
                  <i class="mdi mdi-domain icon-padding-right"/>
                  <span>충전소 운영 정보</span>
                </div>

                <div class="accordion-body-content">
                  <div>
                    <span><i class="mdi mdi-office-building-outline"/></span>
                    <span class="field-text" >
                    {{ !$_utils.isEmpty(chargerResult.busiId) ? $_app.code.busiId[chargerResult.busiId] : '-' }}
                    {{ !$_utils.isEmpty(chargerResult.busiCall) && chargerResult.busiCall !== 'null' ? `/ ${chargerResult.busiCall}` : '' }}</span>
                  </div>
                  <div v-if="!$_utils.isEmpty(chargerResult.useTime)">
                    <span><i class="mdi mdi-clock-time-four-outline"/></span>
                    <span class="field-text" :title="chargerResult.useTime">
                    {{ $_utils.textLengthOverCut(chargerResult.useTime, 32, '') }}
                  </span>
                  </div>
                  <div v-if="!$_utils.isEmpty(chargerResult.parkingFree)">
                    <span><i class="mdi mdi-parking"/></span>
                    <span class="field-text">
                    주차 {{ chargerResult.parkingFree === 'Y' ? '무료' : '유료' }}
                  </span>
                  </div>
                  <div v-if="!$_utils.isEmpty(chargerResult.limitDetail)">
                    <span><i class="mdi mdi-account-multiple"/></span>
                    <span class="field-text" :title="chargerResult.limitDetail">
                    {{ $_utils.textLengthOverCut(chargerResult.limitDetail, 32, '') }}</span>
                  </div>
                </div>
              </div>
              <!-- END Station Info -->

            </div>
          </div>
        </b-collapse>
        <!-- END Acoordion Collapse -->

      </div>
    </div>

    <charge-fee-info-modal ref="chargeFeeModal" :chargePriceResult="chargePriceResult" />


  </div>
</template>

<script>
import ChargeFeeInfoModal from "@/views/pages/maps/ChargeFeeInfoModal.vue";
import { http } from "@/mdk/auth-api";

export default {
  name: "evMapAroundList",
  components: { ChargeFeeInfoModal },
  props: {
    sidebarMode: String, //
    detailOptionCheck: Boolean,
    stationResultList: Array,
    collapseId: String,
    // idx: Number,
    // activeAccordionId: Number,
    // chargerResult: Object,
  },
  data() {
    return {
      isUtzLoading: false,
      isPriceLoading: false,
      // stationResult: null,
      activeAccordionId: null,
      chargerResult: null,
      chargePriceResult: null,
      dcPriceMax: null,
      acPriceMax: null,
      nonMemberPriceMax: null,
      initMapOptions: {      // 필요여부?
        lat: 37.498204,   // 위도 (I-ON)
        lng: 127.032685,   // 경도 (I-ON)
        level: 4,
      },
      chargerUtzChartOptions: {
        series: [],
        chart: {
          type: 'bar',
          // offsetX: 3,
          offsetY: -10,
          parentHeightOffset: 0,
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          tickPlacement: 'on',
          labels: {
            show: false,
            maxHeight: 10,
            rotate: 0,
            hideOverlappingLabels: false,
            offsetY: -5,
            style: { fontSize: ' 0.5rem' },
          },
          axisTicks: { show: false },
          tickAmount: 3,
          tooltip: { enabled: false },
        },
        yaxis: {
          tickAmount: 2,
          max: max => {
            if (max >= 70 || max === 0) return 100;
            else return max + 2;
          },
          labels: {
            show: true,
            minWidth: 0,
            maxWidth: 14,
            style: {
              fontSize: ' 0.5rem',
            },
            formatter: val => val.toFixed(0),
          },
        },
        noData: {
          text: 'Loading...',
          style: { fontSize: '10px' }
        },
        colors: ['#01565b'],
        fill: { opacity: 1 },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '60%',
            colors: {
              ranges: [{
                from: 0,
                to: 0,
                color: '#5aba8a'
              }],
            }
          },
        },
        grid: {
          show: false,
          column: {
            colors: ['#fef5ee']
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        tooltip: {
          enabled: true,
          x: { show: false },
          y: {
            formatter: val => `${val}%`,
            title: {
              formatter: (val, opts) =>
                `${opts.w.globals.labels[opts.dataPointIndex] -1 }~${opts.w.globals.labels[opts.dataPointIndex]}시`
            }
          },
        }
      }
    }
  },
  watch: {
    stationResultList: {
      handler(newVal, oldVal) {
        const vm = this;
        // console.log('LIST -new : ',newVal)
        // console.log('LIST -old : ',oldVal)
        // vm.selectedOptions.keyword = vm.searchKeyword; /
        vm.activeAccordionId = null;
        if (newVal.length === 1) {
          this.$nextTick(() => {
            vm.autoOpenCollapse();
          });
          if (!this.$_utils.isEmpty(oldVal) && (newVal[0].statId === oldVal[0].statId)) {
            this.$root.$emit('bv::toggle::collapse', 'collapse-station-result-0');
          }
        }
        vm.scrollToTop('#search-station-result-accordion');
      },
      immediate: true
    }
  },
  methods: {
    getStationAccordionStyle() {
      let height;

      if (this.$store.state.layout.browserMode === 'web') {
        height = { height: this.detailOptionCheck ? 'calc(100vh - 516px)' : 'calc(100vh - 350px)' }
      } else {
        height = { height: this.detailOptionCheck ? window.innerHeight - 580 + 'px' : window.innerHeight - 350 + 'px' }
      }

      return height;
    },
    getRoadAccordionStyle() {
      let height;

      if (this.$store.state.layout.browserMode === 'web') {
        height = { height: this.detailOptionCheck ? 'calc(100vh - 610px)' : 'calc(100vh - 540px)' }
      } else {
        height = { height: this.detailOptionCheck ? window.innerHeight - 580 + 'px' : window.innerHeight - 350 + 'px' }
      }
      return height;
    },
    autoOpenCollapse() {
      const vm = this;

      vm.activeAccordionId = 0;

      this.$root.$emit('bv::toggle::collapse', 'collapse-station-result-0');

      if (vm.stationResultList[0].price) {
        vm.chargerResult = vm.stationResultList[0];
        vm.chargePriceResult = typeof vm.chargerResult.price === 'string' || this.$_utils.isEmpty(vm.chargerResult.price[0].id)
        ? [] : vm.chargerResult.price;
        vm.fixOpenedAccordionHeader();
        vm.setChargePrice();
      } else {
        if (vm.stationResultList[0].evse) {
          vm.isUtzLoading = true;
          vm.isPriceLoading = true;
          vm.chargerResult =  vm.stationResultList[0];
        } else {
          vm.getEvseItemsDefalut(vm.stationResultList[0]);
          //vm.getEvseItemsWithUtzPrice(vm.stationResultList[0]);
        }
      }
    },
    scrollToTop(element) {
      const searchResultArea = document.querySelector(element);
      if (searchResultArea) {
        searchResultArea.scrollTo(0, 0);
      }
    },
    scrollAmountHandler(e) {
      const vm = this;
      const id = vm.activeAccordionId;

      if (document.querySelector('.collapse.station.show')) {
        const acordionHeaderHeight = document.querySelectorAll('.ct-accordion-header')[0].offsetHeight;
        const openedAccordionHeader = document.querySelector('.ct-accordion-header.not-collapsed');
        const openedAcordionContentHeight = document.querySelector(`.collapse.station.show`).offsetHeight;
        const scrollAmount = e.target.scrollTop;

        if (scrollAmount >= acordionHeaderHeight * id && scrollAmount < acordionHeaderHeight * (id + 1) + openedAcordionContentHeight) {
          openedAccordionHeader.style.position = 'sticky';
          openedAccordionHeader.style.top = 0;
        } else {
          openedAccordionHeader.style.top = null;
        }
      }
    },
    showOnMap(type, subType, item, id) {
      const vm = this;

      const searchResultArea = document.querySelector('#search-station-result-accordion');
      searchResultArea.removeEventListener('scroll', vm.scrollAmountHandler);

      if (vm.activeAccordionId !== id) {
        vm.activeAccordionId = id;
        vm.chargerResult = null;
        vm.chargePriceResult = null;
        vm.setScrollPosition();
        vm.getEvseItemsDefalut(item);
        //vm.getEvseItemsWithUtzPrice(item);
        this.$emit('showOnMap', type, subType, item);
      } else {
        vm.activeAccordionId = null;
      }
    },
    setScrollPosition() {
      const vm = this;

      const searchResultArea = document.querySelector('#search-station-result-accordion');
      const acordionHeaderHeight = document.querySelectorAll('.ct-accordion-header')[0].offsetHeight;

      searchResultArea.scroll({ top: ( acordionHeaderHeight * vm.activeAccordionId ), behavior: "smooth" });
    },
    async getEvseItemsDefalut(item) {
      const vm = this;
      const _url = `/me/cp`;

      try {
        const res = await http.get(_url, {
          params: {
            statId: item.statId,
            lat: vm.initMapOptions.lat,
            lon: vm.initMapOptions.lng
          }
        });
        vm.chargerResult = { ...vm.chargerResult, ...res.data };


        vm.isUtzLoading = true;
        vm.isPriceLoading = true;

        // vm.chargePriceResult = typeof res.data.price === 'string' || this.$_utils.isEmpty(res.data.price[0].id)
        //   ? [] : res.data.price;

        vm.fixOpenedAccordionHeader();
        // vm.setChargePrice();
      } catch(err) {
        console.error(err);
      }
    },
    async getEvseItemsWithUtzPrice(item) {
      const vm = this;
      const _url = `/me/evse/utz`;

      try {
        const res = await http.get(_url, {
          params: {
            statId: item.statId,
            lat: vm.initMapOptions.lat, //
            lon: vm.initMapOptions.lng //
          }
        });
        vm.chargerResult = { ...vm.chargerResult, ...res.data };
        vm.chargePriceResult = typeof res.data.price === 'string' || this.$_utils.isEmpty(res.data.price[0].id)
          ? [] : res.data.price;

        // vm.fixOpenedAccordionHeader();
        vm.setChargePrice();
      } catch(err) {
        console.error(err);
      }
    },
    fixOpenedAccordionHeader() {
      const vm = this;
      const searchResultArea = document.querySelector('#search-station-result-accordion');

      const openedAcordionContent = document.querySelector(`.collapse.station.show`);
      if (openedAcordionContent) {
        searchResultArea.addEventListener('scroll', vm.scrollAmountHandler);
      }
    },
    addFavorites() {
      this.$swal('COMING SOON', '', 'info');
    },
    showNavi(item) {
      this.$emit('showNavi', item);
    },

    setChargePrice() {
      const vm = this;

      const [dcPrices, smAcPrices, wtAcPrices, sfAcPrices, nonMemberPrices] = [[], [], [], [], []];

      for (const ele of vm.chargePriceResult) {
        if (ele.dc_price) {
          Object.values(ele.dc_price).forEach(price => {
            if (price > 0) dcPrices.push(price);
          });
        }
        if (ele.sm_ac_price) {
          Object.values(ele.sm_ac_price).forEach(price => {
            if (price > 0) smAcPrices.push(price);
          });
        }
        if (ele.wt_ac_price) {
          Object.values(ele.wt_ac_price).forEach(price => {
            if (price > 0) wtAcPrices.push(price);
          });
        }
        if (ele.sf_ac_price) {
          Object.values(ele.sf_ac_price).forEach(price => {
            if (price > 0) sfAcPrices.push(price);
          });
        }
        if (ele.non_member_price > 0) nonMemberPrices.push(ele.non_member_price);
      }

      vm.dcPriceMax = dcPrices.length > 0 ? Math.max(...dcPrices) : null;
      vm.acPriceMax = [...smAcPrices, ...wtAcPrices, ...sfAcPrices].length > 0 ? Math.max(...smAcPrices, ...wtAcPrices, ...sfAcPrices) : null;
      vm.nonMemberPriceMax = nonMemberPrices.length > 0 ? Math.max(...nonMemberPrices) : null;

      if (!this.$_utils.isEmpty(vm.chargerResult.utz) && vm.chargerResult.utz.length > 0) {
        this.$nextTick(() => vm.drawUtzChart())
      }
    },
    drawUtzChart() {
      const vm = this;
      const utzDataCopy = [...vm.chargerResult.utz];

      vm.isUtzLoading = false;
      vm.isPriceLoading = false;

      utzDataCopy.sort((a, b) => b - a);

      const nthData = utzDataCopy[2];
      vm.chargerUtzChartOptions.plotOptions.bar.colors.ranges[0].to = nthData - 1;

      if (vm.chargePriceResult.length > 0 && vm.chargePriceResult[0]['sf_ac_price']) {
        const _colors = vm.getChartBgColor();
        // console.log('colors ', _colors)
        this.$refs.stationUtzChart[0].updateOptions({ grid: { column: { colors: _colors } } });
      }

      this.$refs.stationUtzChart[0].updateSeries([{ name: '충전소 이용률', data: vm.chargerResult.utz }]);
    },
    getChartBgColor() {
      const vm = this;
      const currentMonth = new Date().getMonth() + 1;

      let bgLight = '#fef5ee', bgHeavy = '#fddbc3', bgMax = '#f6b991';
      let _color = Array(24);

      const seasonFeeValues = (seasonAcPrice) => Object.values(vm.chargePriceResult[0][seasonAcPrice]);
      if ((currentMonth >= 3 && currentMonth <= 5) || (currentMonth >= 9 && currentMonth <= 10)) {
        // spring or fall **max[0], heavy[1], light[2]
        if (seasonFeeValues('sf_ac_price').every(value => value === seasonFeeValues('sf_ac_price')[0])) {
          //경부하 = 중부하= 최대부하
          bgHeavy = '#fef5ee';
          bgMax = '#fef5ee';
        } else if (seasonFeeValues('sf_ac_price')[2] === seasonFeeValues('sf_ac_price')[1]) {
          //경부하 = 중부하
          bgHeavy = '#fef5ee';
          bgMax = '#fddbc3';
        } else if (seasonFeeValues('sf_ac_price')[1] === seasonFeeValues('sf_ac_price')[0]) {
          //중부하 = 최대부하
          bgHeavy = '#fddbc3';
          bgMax = '#fddbc3';
        } else if (seasonFeeValues('sf_ac_price')[2] === seasonFeeValues('sf_ac_price')[0]) {
          //경부하 = 최대부하
          bgMax = '#fef5ee';
        }
        return _color
          .fill(bgLight, 22, 24)
          .fill(bgLight, 0, 8)
          .fill(bgHeavy, 8, 11)
          .fill(bgHeavy, 12, 13)
          .fill(bgHeavy, 18, 22)
          .fill(bgMax, 11, 12)
          .fill(bgMax, 13, 18);
      } else if (currentMonth >= 6 && currentMonth <= 8) {
        // summer
        if (seasonFeeValues('sm_ac_price').every(value => value === seasonFeeValues('sf_ac_price')[0])) {
          //경부하 = 중부하= 최대부하
          bgLight = '#fef5ee';
          bgHeavy = '#fef5ee';
          bgMax = '#fef5ee';
        } else if (seasonFeeValues('sm_ac_price')[2] === seasonFeeValues('sm_ac_price')[1]) {
          //경부하 = 중부하
          bgHeavy = '#fef5ee';
          bgMax = '#fddbc3';
        } else if (seasonFeeValues('sm_ac_price')[1] === seasonFeeValues('sm_ac_price')[0]) {
          //중부하 = 최대부하
          bgHeavy = '#fddbc3';
          bgMax = '#fddbc3';
        } else if (seasonFeeValues('sm_ac_price')[2] === seasonFeeValues('sf_ac_price')[0]) {
          //경부하 = 최대부하
          bgMax = '#fef5ee';
        }
        return _color
          .fill(bgLight, 22, 24)
          .fill(bgLight, 0, 8)
          .fill(bgHeavy, 8, 11)
          .fill(bgHeavy, 12, 13)
          .fill(bgHeavy, 18, 22)
          .fill(bgMax, 11, 12)
          .fill(bgMax, 13, 18);
      } else {
        // winter
        if (seasonFeeValues('wt_ac_price').every(value => value === seasonFeeValues('sf_ac_price')[0])) {
          //경부하 = 중부하= 최대부하
          bgLight = '#fef5ee';
          bgHeavy = '#fef5ee';
          bgMax = '#fef5ee';
        } else if (seasonFeeValues('wt_ac_price')[2] === seasonFeeValues('wt_ac_price')[1]) {
          //경부하 = 중부하
          bgHeavy = '#fef5ee';
          bgMax = '#fddbc3';
        } else if (seasonFeeValues('wt_ac_price')[1] === seasonFeeValues('wt_ac_price')[0]) {
          //중부하 = 최대부하
          bgHeavy = '#fddbc3';
          bgMax = '#fddbc3';
        } else if (seasonFeeValues('wt_ac_price')[2] === seasonFeeValues('sf_ac_price')[0]) {
          //경부하 = 최대부하
          bgMax = '#fef5ee';
        }
        return _color
          .fill(bgLight, 22, 24)
          .fill(bgLight, 0, 8)
          .fill(bgHeavy, 8, 11)
          .fill(bgHeavy, 12, 13)
          .fill(bgHeavy, 18, 22)
          .fill(bgMax, 11, 12)
          .fill(bgMax, 13, 18);
      }
    },
    getStatusName(val) {
      switch (val) {
        case 1: return '충전 가능';
        case 2: return '충전중';
        case 3: return '고장 / 점검';
        case 4: return '상태 미확인';
        default: return '-';
      }
    },
    openChargeFeeModal() {
      this.$nextTick(() => this.$refs.chargeFeeModal.show());
    },
  }
}
</script>